import { render, staticRenderFns } from "./Finalizado.vue?vue&type=template&id=32069a2b&scoped=true"
import script from "./Finalizado.vue?vue&type=script&lang=js"
export * from "./Finalizado.vue?vue&type=script&lang=js"
import style0 from "./Finalizado.vue?vue&type=style&index=0&id=32069a2b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32069a2b",
  null
  
)

export default component.exports